import { render, staticRenderFns } from "./ActivityHeader.vue?vue&type=template&id=3b662aa8&scoped=true&"
import script from "./ActivityHeader.vue?vue&type=script&lang=js&"
export * from "./ActivityHeader.vue?vue&type=script&lang=js&"
import style0 from "./ActivityHeader.vue?vue&type=style&index=0&id=3b662aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b662aa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b662aa8')) {
      api.createRecord('3b662aa8', component.options)
    } else {
      api.reload('3b662aa8', component.options)
    }
    module.hot.accept("./ActivityHeader.vue?vue&type=template&id=3b662aa8&scoped=true&", function () {
      api.rerender('3b662aa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActivityHeader.vue"
export default component.exports